module.exports = require("echarts");